var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 21.083a9.52 9.52 0 0 1-6.747-2.779 9.5 9.5 0 0 1-2.836-6.766c-.02-5.28 4.264-9.602 9.545-9.621 2.578 0 4.974.977 6.785 2.779a9.5 9.5 0 0 1 2.836 6.766c.02 5.28-4.264 9.602-9.545 9.621zM3.833 11.53c0 2.05.815 3.967 2.272 5.414a7.6 7.6 0 0 0 5.395 2.224h.029c4.226-.02 7.647-3.47 7.638-7.696 0-2.05-.815-3.967-2.272-5.414A7.6 7.6 0 0 0 11.5 3.833h-.029c-4.226.02-7.647 3.47-7.638 7.696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.74a1.073 1.073 0 1 0 0-2.147 1.073 1.073 0 0 0 0 2.147M11.5 16.77a.96.96 0 0 1-.958-.957V11.02c0-.527.43-.959.958-.959.527 0 .958.432.958.959v4.791a.96.96 0 0 1-.958.959"
  })));
};
export default SvgInfo;